/*
 * lvh-reviews.js — Lavior's real Yotpo reviews, drawn in the site's own style (Oct 2026).
 *
 * Reads Yotpo's public read-only widget API (the same one Yotpo's own widgets use) with the store's public app key,
 * which sections/lvh-site.liquid passes in data-key. Nothing here is invented: counts and averages come straight
 * from Yotpo, and an element with no reviews stays hidden.
 *
 *   [data-lvh-stars="<product id>"]   star rating + average (product cards). Owner, Oct 2026: no review counts
 *                                     anywhere ("looks super lite"); averages only.
 *   [data-lvh-reviews]                the homepage carousel: data-products = [{id,title,line,url}],
 *                                     data-ids = which review ids to feature, in order (blank = newest 4-5 stars)
 *   [data-lvh-previews="<product id>"] product page reviews section (sections/lvh-product-reviews.liquid, Oct 13
 *                                     2026): this product's Yotpo average and its reviews, six at a time. The
 *                                     hero rating on the product page links down to it.
 */
(function () {
  var s = document.querySelector('script[data-lvh-reviews-key]');
  var KEY = s && s.getAttribute('data-lvh-reviews-key');
  if (!KEY) return;
  // Owner, Oct 13 2026: lavior.com (Yotpo) ratings only; other stores' ratings are no longer shown.
  // SNAP is the Yotpo average and count per reviewed product as of Oct 13 2026. It is used only when Yotpo can't be
  // reached (slow network, a browser blocking it) so the stars never leave an empty gap, and to work out the
  // average across Lavior products for a product with no reviews yet (labeled as such). Refresh it now and then.
  var SNAP = {
    '9714874450195': { name: 'Diabetic Wound Hydrogel', avg: 5.0, n: 5 },
    '9714878611731': { name: 'Multipurpose Wound Gel', avg: 5.0, n: 3 },
    '9714882445587': { name: 'Diabetic Skin Barrier Cream', avg: 4.91, n: 11 }
  };
  var cache = {};
  function get(pid, n) {
    var k = pid + ':' + n;
    if (!cache[k]) {
      var live = fetch('https://api-cdn.yotpo.com/v1/widget/' + KEY + '/products/' + encodeURIComponent(pid) + '/reviews.json?per_page=' + n + '&page=1')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return j && j.response ? j.response : null; })
        .catch(function () { return null; });
      var late = new Promise(function (res) { setTimeout(function () { res(null); }, 3500); });
      cache[k] = Promise.race([live, late]).then(function (r) {
        if (r) return r;
        var sn = SNAP[String(pid)];
        return sn ? { bottomline: { average_score: sn.avg, total_review: sn.n }, reviews: [], snapshot: true } : null;
      });
    }
    return cache[k];
  }
  function dec(t) { var ta = document.createElement('textarea'); ta.innerHTML = t == null ? '' : String(t); return ta.value; }
  function clip(t, n) { t = dec(t); return t.length > n ? t.slice(0, n).replace(/\s+\S*$/, '') + '…' : t; }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
  function starRow(score) {
    return '<span class="lvr-row" style="--r:' + (Math.max(0, Math.min(5, score)) / 5 * 100).toFixed(1) + '%" aria-hidden="true"><span class="bg">★★★★★</span><span class="fg">★★★★★</span></span>';
  }

  /* Section-built cards (main-collection, related products) carry no product id: their title link is
     a[class*="__name-link-"]. Look the id up from the product's .js and add a stars hook under the title. */
  function hookCards() {
    document.querySelectorAll('a[class*="__name-link-"][href*="/products/"]').forEach(function (a) {
      if (a.dataset.lvhHooked) return; a.dataset.lvhHooked = '1';
      var h = a.getAttribute('href').split('?')[0].split('#')[0];
      fetch(h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p || !p.id) return;
        var d = document.createElement('div');
        d.className = 'lvr-stars lvr-c'; d.hidden = true; d.setAttribute('data-lvh-stars', p.id);
        a.insertAdjacentElement('afterend', d); stars();
      }).catch(function () {});
    });
  }

  // Average across every reviewed Lavior product (live from Yotpo, or SNAP), weighted by review count.
  var brandP = null;
  function brand() {
    if (!brandP) brandP = Promise.all(Object.keys(SNAP).map(function (id) { return get(id, 1); })).then(function (rs) {
      var n = 0, sum = 0;
      rs.forEach(function (r) { var b = r && r.bottomline; if (b && b.total_review) { n += b.total_review; sum += b.average_score * b.total_review; } });
      return n ? { avg: sum / n, n: n } : null;
    });
    return brandP;
  }

  function stars() {
    document.querySelectorAll('[data-lvh-stars]').forEach(function (el) {
      if (el.dataset.lvhDone) return; el.dataset.lvhDone = '1';
      get(el.getAttribute('data-lvh-stars'), 1).then(function (r) {
        var b = r && r.bottomline;
        if (!b || !b.total_review) {
          brand().then(function (x) {
            if (!x) return;
            var sc = x.avg.toFixed(1);
            el.innerHTML = starRow(x.avg) + '<span class="lvr-n">' + sc + ' <span>Lavior average</span></span>';
            el.setAttribute('role', 'img'); el.setAttribute('aria-label', 'Lavior products are rated ' + sc + ' out of 5 on average');
            el.hidden = false;
          });
          return;
        }
        var avg = Number(b.average_score).toFixed(1);
        el.innerHTML = starRow(b.average_score) + '<span class="lvr-n">' + avg + '</span>';
        el.setAttribute('role', 'img');
        el.setAttribute('aria-label', 'Rated ' + avg + ' out of 5');
        el.hidden = false;
      });
    });
  }

  function carousel() {
    document.querySelectorAll('[data-lvh-reviews]').forEach(function (root) {
      if (root.dataset.lvhDone) return; root.dataset.lvhDone = '1';
      var prods = []; try { prods = JSON.parse(root.getAttribute('data-products') || '[]'); } catch (e) {}
      var ids = (root.getAttribute('data-ids') || '').split(/[\s,]+/).filter(Boolean);
      Promise.all(prods.map(function (p) { return get(p.id, 50); })).then(function (res) {
        var all = [], total = 0, sum = 0;
        res.forEach(function (r, i) {
          if (!r) return;
          total += r.bottomline.total_review; sum += r.bottomline.average_score * r.bottomline.total_review;
          r.reviews.forEach(function (v) { v._p = prods[i]; all.push(v); });
        });
        var picked = ids.length
          ? ids.map(function (id) { return all.find(function (v) { return String(v.id) === id; }); }).filter(Boolean)
          : all.filter(function (v) { return v.score >= 4 && v.content && v.content.length > 20; })
               .sort(function (a, b) { return b.created_at.localeCompare(a.created_at); }).slice(0, 9);
        if (!picked.length || !total) { root.hidden = true; return; }
        var avg = (sum / total).toFixed(1);
        var sum$ = root.querySelector('[data-lvr-summary]');
        if (sum$) sum$.innerHTML = starRow(sum / total) + '<b>' + avg + ' out of 5</b><span>average customer rating</span>';
        var track = root.querySelector('[data-lvr-track]');
        track.innerHTML = picked.map(function (v) {
          var name = v.user && v.user.display_name ? dec(v.user.display_name) : 'Lavior customer';
          var p = v._p || {};
          return '<article class="lvr-card line-' + esc(p.line || 'dia') + '">' +
            starRow(v.score) +
            '<h3>' + esc(dec(v.title)) + '</h3>' +
            '<p>' + esc(clip(v.content, 320)) + '</p>' +
            '<div class="lvr-foot"><span class="who"><b>' + esc(name) + '</b>' + (v.verified_buyer ? '<span class="vb">Verified buyer</span>' : '') + '</span>' +
            (p.url ? '<a class="prod" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' : '') + '</div></article>';
        }).join('');
        root.hidden = false;
        var prev = root.querySelector('[data-lvr-prev]'), next = root.querySelector('[data-lvr-next]');
        function step(d) { var c = track.querySelector('.lvr-card'); track.scrollBy({ left: d * ((c ? c.offsetWidth : 320) + 16), behavior: 'smooth' }); }
        if (prev) prev.addEventListener('click', function () { step(-1); });
        if (next) next.addEventListener('click', function () { step(1); });
      });
    });
  }

  function productReviews() {
    document.querySelectorAll('[data-lvh-previews]').forEach(function (root) {
      if (root.dataset.lvhDone) return; root.dataset.lvhDone = '1';
      var pid = root.getAttribute('data-lvh-previews');
      get(pid, 100).then(function (r) {
        var b = r && r.bottomline;
        var own = root.querySelector('[data-lvpr-own]');
        if (!b || !b.total_review) {
          // No reviews for this product yet: show the Lavior-wide average (labeled) and recent reviews of the other
          // Lavior products, each marked with the product it's about.
          return Promise.all([brand()].concat(Object.keys(SNAP).map(function (id) { return get(id, 100); }))).then(function (all) {
            var x = all[0];
            if (!x) { root.hidden = true; return; }
            if (own) {
              own.querySelector('.src').textContent = 'Lavior average';
              own.querySelector('[data-lvpr-avg]').textContent = x.avg.toFixed(1);
              own.querySelector('[data-lvpr-stars]').innerHTML = starRow(x.avg);
              own.querySelector('.go').textContent = 'Across all Lavior products ↓';
              own.hidden = false;
            }
            var ids = Object.keys(SNAP), merged = [];
            all.slice(1).forEach(function (rr, i) { (rr && rr.reviews || []).forEach(function (v) { v._pn = SNAP[ids[i]].name; merged.push(v); }); });
            merged.sort(function (a, c) { return (c.created_at || '').localeCompare(a.created_at || ''); });
            list_(merged);
          });
        }
        if (own) {
          own.querySelector('[data-lvpr-avg]').textContent = Number(b.average_score).toFixed(1);
          own.querySelector('[data-lvpr-stars]').innerHTML = starRow(b.average_score);
          own.hidden = false;
        }
        list_(r.reviews || []);
      });
      function list_(reviews) {
        var list = root.querySelector('[data-lvpr-list]'), more = root.querySelector('[data-lvpr-more]');
        // Same rule as the homepage carousel: reviews that make health claims (healed, cures, infection...) or say
        // almost nothing aren't featured here. The average above still counts every review.
        var claim = /\b(heal|cure|treat|prevent|infect|antibacter|antimicrob|antisept|bacteri|scar)/i;
        var revs = reviews.filter(function (v) {
          var t = dec(v.title) + ' ' + dec(v.content);
          return v.score >= 4 && dec(v.content).replace(/[^A-Za-z]/g, '').length >= 15 && !claim.test(t);
        });
        if (!list || !revs.length) return;
        var shown = 0;
        function draw() {
          list.insertAdjacentHTML('beforeend', revs.slice(shown, shown + 6).map(function (v) {
            var name = v.user && v.user.display_name ? dec(v.user.display_name) : 'Lavior customer';
            return '<article class="lvpr-card">' + starRow(v.score) +
              (v.title ? '<h3>' + esc(dec(v.title)) + '</h3>' : '') +
              '<p>' + esc(clip(v.content, 420)) + '</p>' +
              '<div class="who"><b>' + esc(name) + '</b>' + (v.verified_buyer ? '<span class="vb">Verified buyer</span>' : '') +
              (v._pn ? '<span class="pn">' + esc(v._pn) + '</span>' : '') +
              '<span>' + esc((v.created_at || '').slice(0, 10)) + '</span></div></article>';
          }).join(''));
          shown += 6;
          if (more) more.hidden = shown >= revs.length;
        }
        draw(); list.hidden = false;
        if (more) more.querySelector('button').addEventListener('click', draw);
      }
    });
  }

  // Wrap the product page's hero rating in a link to the reviews section when the page has one.
  function linkBar(bar) {
    var target = document.getElementById('lvh-reviews');
    var inner = bar.querySelector('.lvr-bar');
    if (!target || !inner) return;
    var a = document.createElement('a');
    a.className = 'lvr-bar-link'; a.href = '#lvh-reviews';
    inner.parentNode.insertBefore(a, inner); a.appendChild(inner);
    // a store-rating link inside would nest anchors; keep it as plain text
    inner.querySelectorAll('a').forEach(function (x) { var s = document.createElement('span'); s.textContent = x.textContent; x.replaceWith(s); });
  }

  /* Product page: the theme's hero review bar carried a typed-in "4,200+ Verified Reviews". Replace it with this
     product's real Yotpo rating; with no reviews the bar stays hidden (lvh-plus.css hides it until filled). */
  function productBar() {
    var bar = document.querySelector('[class^="hero-review-bar-"]');
    if (!bar || bar.dataset.lvhDone) return; bar.dataset.lvhDone = '1';
    var m = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (!m || !m.id) return;
    get(m.id, 1).then(function (r) {
      var b = r && r.bottomline;
      if (!b || !b.total_review) {
        // No reviews for this product yet (owner, Oct 13 2026): show the average across Lavior products, labeled.
        brand().then(function (x) {
          if (!x) { bar.remove(); return; }
          var sc = x.avg.toFixed(1);
          bar.innerHTML = '<span class="lvr-bar">' + starRow(x.avg) + '<b>' + sc + ' out of 5</b><span>average across Lavior products</span></span>';
          bar.setAttribute('aria-label', 'Lavior products are rated ' + sc + ' out of 5 on average');
          linkBar(bar); bar.classList.add('lvr-ready');
        });
        return;
      }
      var avg = Number(b.average_score).toFixed(1);
      bar.innerHTML = '<span class="lvr-bar">' + starRow(b.average_score) + '<b>' + avg + ' out of 5</b></span>';
      bar.setAttribute('aria-label', 'Rated ' + avg + ' out of 5');
      linkBar(bar); bar.classList.add('lvr-ready');
    });
  }

  function run() { hookCards(); stars(); carousel(); productReviews(); productBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // product grids that load more items (filters, infinite scroll)
  // (batched: apps such as the translator and chat change the page often, so scan at most every 250 ms)
  var mt = 0;
  new MutationObserver(function () { if (mt) return; mt = setTimeout(function () { mt = 0; hookCards(); stars(); }, 250); }).observe(document.documentElement, { childList: true, subtree: true });
})();
